document.addEventListener("DOMContentLoaded", function () {

  /* ================================
     SCROLL REVEAL
     ================================ */

  const revealElements = document.querySelectorAll(
    ".shopify-section > div, .multicolumn-list__item, .image-with-text, .banner__box"
  );

  const revealObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("scroll-reveal-visible");
          revealObserver.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.12,
      rootMargin: "0px 0px -50px 0px"
    }
  );

  revealElements.forEach((element) => {
    element.classList.add("scroll-reveal");
    revealObserver.observe(element);
  });


  /* ================================
     CINEMATIC IMAGE REVEAL
     ================================ */

  const imageElements = document.querySelectorAll(
    ".banner__media img, .image-with-text__media img, .multicolumn-card__image-wrapper img, .card__media img"
  );

  const imageObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("cinematic-image-visible");
          imageObserver.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.15,
      rootMargin: "0px 0px -60px 0px"
    }
  );

  imageElements.forEach((image) => {
    image.classList.add("cinematic-image");
    imageObserver.observe(image);
  });


  /* ================================
     STAGGERED TEXT REVEAL
     ================================ */

  const textSections = document.querySelectorAll(".rich-text");

  const textObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("luxury-text-visible");
          textObserver.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.2,
      rootMargin: "0px 0px -40px 0px"
    }
  );

  textSections.forEach((section) => {
    section.classList.add("luxury-text-reveal");
    textObserver.observe(section);
  });


  /* ================================
     LUXURY LARGE HEADINGS
     ================================ */

  const largeHeadings = document.querySelectorAll(
    ".banner__heading, .image-with-text__heading, .rich-text__heading"
  );

  const headingObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("luxury-heading-visible");
          headingObserver.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.25
    }
  );

  largeHeadings.forEach((heading) => {
    heading.classList.add("luxury-heading");
    headingObserver.observe(heading);
  });


  /* ================================
     SUBTLE PARALLAX
     ================================ */

  const parallaxImages = document.querySelectorAll(
    ".banner__media img, .image-with-text__media img"
  );

  let ticking = false;

  function updateParallax() {

    parallaxImages.forEach((image) => {

      const rect = image.getBoundingClientRect();

      if (rect.bottom > 0 && rect.top < window.innerHeight) {

        const center = window.innerHeight / 2;
        const imageCenter = rect.top + rect.height / 2;

        const movement = (imageCenter - center) * -0.035;

        image.style.setProperty(
          "--parallax-y",
          `${movement}px`
        );
      }
    });

    ticking = false;
  }

  window.addEventListener(
    "scroll",
    function () {

      if (!ticking) {

        window.requestAnimationFrame(updateParallax);

        ticking = true;
      }

    },
    { passive: true }
  );


  /* ================================
     ARROW MICRO INTERACTION
     ================================ */

  const arrowLinks = document.querySelectorAll(
    "a .icon-arrow, a .icon-caret"
  );

  arrowLinks.forEach((arrow) => {

    const parent = arrow.closest("a");

    if (!parent) return;

    parent.addEventListener("mouseenter", () => {
      arrow.classList.add("luxury-arrow-active");
    });

    parent.addEventListener("mouseleave", () => {
      arrow.classList.remove("luxury-arrow-active");
    });

  });

});